import { createStore } from 'satcheljs';
import ActionConfirmationsOptionState from './schema/ActionConfirmationsOptionState';

export default createStore<ActionConfirmationsOptionState>('actionConfirmationsOption', {
    actionConfirmationsEnabled: null,
});
